var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 46,
    viewBox: "0 0 37 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4,39.9A5.4,5.4,0,0,1,6,34.4V8.9H2.4A2.46,2.46,0,0,0,0,11.4V43.5A2.46,2.46,0,0,0,2.4,46H25.6A2.46,2.46,0,0,0,28,43.5V40H11.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7,0H11.4A2.46,2.46,0,0,0,9,2.5V34.6a2.46,2.46,0,0,0,2.4,2.5H34.6A2.46,2.46,0,0,0,37,34.6V8.7L34.4,6.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFiles);
export default __webpack_public_path__ + "static/media/icon-files.71d28f4dad971922d0aed51da858b04f.svg";
export { ForwardRef as ReactComponent };